
// import React from "react";
import ReactDOM from "react-dom";
import Root from "./Root";
console.log = function () { };
ReactDOM.render(<Root />, document.getElementById("root"));
